import {
  Dialog,
  DialogContainer,
  DialogHeader,
  DialogSubtitle,
  DialogTopTitle,
} from './Dialog.styles'
import { useTheme } from '@emotion/react'
import { useEffect } from 'react'
import { SquareLoader } from 'react-spinners'

export const CreatingOrgDialog = ({ onComplete }: { onComplete: () => void }) => {
  const theme = useTheme()

  useEffect(() => {
    const id = setTimeout(() => {
      onComplete()
    }, 2000)

    return () => clearTimeout(id)
  }, [])

  return (
    <DialogContainer>
      <Dialog>
        <div>
          <SquareLoader size="5rem" color={theme.primary} />
        </div>
        <DialogTopTitle style={{ marginTop: '2rem' }}>Steg 3 av 3</DialogTopTitle>
        <DialogHeader>Skapar din hemsida</DialogHeader>
        <DialogSubtitle>Det här tar bara några sekunder</DialogSubtitle>
      </Dialog>
    </DialogContainer>
  )
}
